export const FooterLinks = [
  {
    id: 91,
    name: "LinkedIn",
    path: "https://www.linkedin.com/in/vlad-khrushchov-59a83b380/",
  },
  { id: 92, name: "GitHub", path: "https://github.com/Vladoosik" },
  { id: 93, name: "GitLab", path: "https://gitlab.com/Vladoosik" },
  { id: 95, name: "Telegram", path: "https://t.me/vladoosik1" },
];
